import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, CalendarDays, Settings, BarChart, ArrowLeft } from 'lucide-react';
import { HabbitLogo } from './HabbitLogo';
interface AppShellProps {
  children: React.ReactNode;
}
export function AppShell({
  children
}: AppShellProps) {
  const location = useLocation();
  const navItems = [{
    path: '/app',
    label: 'Command',
    icon: LayoutDashboard
  }, {
    path: '/app/calendar',
    label: 'Grid',
    icon: CalendarDays
  }, {
    path: '/app/analytics',
    label: 'Analytics',
    icon: BarChart
  }, {
    path: '/app/settings',
    label: 'Settings',
    icon: Settings
  }];
  return <div className="min-h-screen bg-[#0a0a0a] text-gray-200 flex flex-col font-sans selection:bg-centurion-500/30" data-id="element-76">
      {/* Top Navigation Bar */}
      <header className="sticky top-0 z-50 bg-surface-500/80 backdrop-blur-md border-b border-surface-100" data-id="element-77">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between" data-id="element-78">
          <div className="flex items-center gap-4" data-id="element-79">
            <Link to="/" className="hidden sm:flex text-xs text-gray-400 hover:text-gray-200 items-center gap-1 transition-colors mr-2" data-id="element-80">
              <ArrowLeft size={14} data-id="element-81" /> habbit.at
            </Link>
            <div className="flex items-center gap-3" data-id="element-82">
              <HabbitLogo size={32} data-id="element-83" />
              <span className="font-mono font-bold text-xl tracking-tight text-gray-100" data-id="element-84">
                habbit<span className="text-centurion-500" data-id="element-85">.</span>
              </span>
            </div>
          </div>

          <div className="hidden sm:flex items-center gap-1" data-id="element-86">
            {navItems.map(item => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return <Link key={item.path} to={item.path} className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-2 ${isActive ? 'bg-surface-200 text-centurion-500' : 'text-gray-400 hover:text-gray-200 hover:bg-surface-300'}`} data-id="element-87">
                  <Icon size={16} data-id="element-88" />
                  {item.label}
                </Link>;
          })}
          </div>
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 py-8 sm:py-12" data-id="element-89">
        {children}
      </main>

      {/* Mobile Bottom Navigation */}
      <nav className="sm:hidden fixed bottom-0 left-0 right-0 bg-surface-400 border-t border-surface-100 pb-safe z-50" data-id="element-90">
        <div className="flex justify-around items-center h-16" data-id="element-91">
          {navItems.map(item => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;
          return <Link key={item.path} to={item.path} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${isActive ? 'text-centurion-500' : 'text-gray-500'}`} data-id="element-92">
                <Icon size={20} className={isActive ? 'drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]' : ''} data-id="element-93" />
                <span className="text-[10px] uppercase tracking-wider font-semibold" data-id="element-94">
                  {item.label}
                </span>
              </Link>;
        })}
        </div>
      </nav>
    </div>;
}